import Layout from '../../Layout/Layout';
import { NavLink } from 'react-router-dom';
import Masonry from 'react-masonry-css';
import { Container, Row, Col, Button, Card, CardBody, Nav, NavItem } from 'reactstrap';
import { useTranslator } from '@front-activerse/common-components';
import TitleBar from '../../Layout/TitleBar';

const ArticleListContainerPlaceholder = ({ categories }) => {
  const { t } = useTranslator();

  const breakpointColumnsObj = {
    default: 3,
    992: 2,
    500: 1,
  };

  const renderArticleCards = () => {
    const cards = [];
    const cardsCount = 6;

    for (let i = 0; i < cardsCount; i++) {
      cards.push(
        <Card key={i}>
          <div className="thumbImg placeholder"></div>
          <CardBody>
            <div>
              <span className="category placeholder">leczenie</span>
            </div>
            <h2 className="title-medium semi-bold on-background mt-3 ">
              <span className="placeholder">Prawidłowe</span>
              <span className="placeholder ms-2">odżywianie</span>
              <span className="placeholder ms-2">Dieta</span>
              <span className="placeholder">cukrzycy</span>
              <span className="placeholder ms-2">typu 1</span>
            </h2>
            <div className="article-teaser">
              <p className="placeholder">
                Przede wszystkim należy zaznaczyć, że odpowiednia aktywnosć fizyczna w...
              </p>
              <Button color="link" size="sm" className="px-0 py-0 placeholder">
                {t('feedCard.readMore.button')}
              </Button>
            </div>
          </CardBody>
        </Card>
      );
    }

    return cards;
  };

  const renderFilters = () => {
    return (
      <div className="sub-navigation">
        <Container>
          <Nav className="d-block">
            {categories.map((cat) => (
              <NavItem key={cat}>
                <NavLink to={`/knowledge/${cat}`} className="nav-link">
                  {t(`feed.submenuItem.${cat}`)}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </Container>
      </div>
    );
  };

  return (
    <Layout>
      <TitleBar showBackBtn={false}>{t('feed.navbarTitle')}</TitleBar>

      <div className="page-template-knowledge">
        <Container className="py-md-4">
          <Row>
            <Col xl={{ size: 10, offset: 1 }}>
              <div className="page-container">
                {renderFilters()}
                <div className="article-list-container">
                  <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="my-masonry-grid placeholder-glow"
                    columnClassName="my-masonry-grid_column"
                  >
                    {renderArticleCards()}
                  </Masonry>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default ArticleListContainerPlaceholder;
